<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card card-custom gutter-b card-stretch">
          <!--begin::Header-->
          <div class="card-header border-0">
            <h3 class="card-title font-weight-bolder text-dark">{{$t('user_detail.reading_message')}}</h3>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body pt-2">
            <div class="row mb-5 mt-5">
              <div class="col-md-3">
                <b-form-group label="Kategori">
                  <b-form-select
                      v-model="form.category_id"
                      class="form-control form-control-solid"
                      :options="categories"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Mesaj Durumu">
                  <b-form-select
                      v-model="form.message_id"
                      class="form-control form-control-solid"
                      :options="messages"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Kart Adı">
                  <b-form-input
                      type="text"
                      required
                      class="form-control form-control-solid"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-3">
                <b-form-group label="Email Başlığı">
                  <b-form-input
                      type="text"
                      required
                      class="form-control form-control-solid"
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-12">
                <div class="fa-pull-right mt-9">
                  <b-button-group>
                    <b-button size="sm"><i class="fas fa-search mr-2"></i> Ara</b-button>
                    <b-button size="sm"><i class="far fa-file-excel mr-2"></i> Excel'e Aktar</b-button>
                  </b-button-group>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-table
                    :bordered="table.bordered"
                    :outlined="table.outlined"
                    :small="table.small"
                    :hover="table.hover"
                    :fixed="table.fixed"
                    :items="table.items"
                    :head-variant="table.headvariant"
                ></b-table>
              </div>
            </div>
          </div>
          <!--end::Body-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";

export default {
  name: "Invitation",
  components: {DataTable},
  data() {
    return {
      form : {
        category_id : null,
        message_id : null
      },
      table : {
        bordered : true,
        outlined : true,
        small : true,
        fixed : true,
        hover : true,
        headvariant : 'light',
        items: [
          { 'Tip1': 'SRV', 'Tip2': "SSI", 'Kart Adı': "12512-TvDizi_2", 'Mesaj Durumu' : 'OPN', 'Email Başlığı': '', 'SMS' : '', 'GönderilmeTarihi' : '22.11.2020', 'Okunma Tarihi' : '22.11.2020' },
          { 'Tip1': 'SRV', 'Tip2': "SSI", 'Kart Adı': "12512-TvDizi_2", 'Mesaj Durumu' : 'OPN', 'Email Başlığı': '', 'SMS' : '', 'GönderilmeTarihi' : '22.11.2020', 'Okunma Tarihi' : '22.11.2020' },
          { 'Tip1': 'SRV', 'Tip2': "SSI", 'Kart Adı': "12512-TvDizi_2", 'Mesaj Durumu' : 'OPN', 'Email Başlığı': '', 'SMS' : '', 'GönderilmeTarihi' : '22.11.2020', 'Okunma Tarihi' : '22.11.2020' },
          { 'Tip1': 'SRV', 'Tip2': "SSI", 'Kart Adı': "12512-TvDizi_2", 'Mesaj Durumu' : 'OPN', 'Email Başlığı': '', 'SMS' : '', 'GönderilmeTarihi' : '22.11.2020', 'Okunma Tarihi' : '22.11.2020' },
          { 'Tip1': 'SRV', 'Tip2': "SSI", 'Kart Adı': "12512-TvDizi_2", 'Mesaj Durumu' : 'OPN', 'Email Başlığı': '', 'SMS' : '', 'GönderilmeTarihi' : '22.11.2020', 'Okunma Tarihi' : '22.11.2020' },
          { 'Tip1': 'SRV', 'Tip2': "SSI", 'Kart Adı': "12512-TvDizi_2", 'Mesaj Durumu' : 'OPN', 'Email Başlığı': '', 'SMS' : '', 'GönderilmeTarihi' : '22.11.2020', 'Okunma Tarihi' : '22.11.2020' },
          { 'Tip1': 'SRV', 'Tip2': "SSI", 'Kart Adı': "12512-TvDizi_2", 'Mesaj Durumu' : 'OPN', 'Email Başlığı': '', 'SMS' : '', 'GönderilmeTarihi' : '22.11.2020', 'Okunma Tarihi' : '22.11.2020' },
          { 'Tip1': 'SRV', 'Tip2': "SSI", 'Kart Adı': "12512-TvDizi_2", 'Mesaj Durumu' : 'OPN', 'Email Başlığı': '', 'SMS' : '', 'GönderilmeTarihi' : '22.11.2020', 'Okunma Tarihi' : '22.11.2020' },
          { 'Tip1': 'SRV', 'Tip2': "SSI", 'Kart Adı': "12512-TvDizi_2", 'Mesaj Durumu' : 'OPN', 'Email Başlığı': '', 'SMS' : '', 'GönderilmeTarihi' : '22.11.2020', 'Okunma Tarihi' : '22.11.2020' },
        ],
      },
      categories: [{ text: 'Tümü', value: null } , 'EML','SMS', 'SRV', 'VID'],
      messages: [{ text: 'Tümü', value: null } , 'BLS','ERR', 'HBN', 'NEW','OPN','QUE','SBN','SNT'],

    }
  },
};
</script>
